import * as React from "react";
import "../../assets/scss/components/header/header.scss";
import urlConfig, { config } from "../../config/domain";
import GuestNav from "./guestNav/guestNav";
import { MenuList } from "./menuItems/menuList";
import ee from "../utils/eventEmitter";
import { LoginToNav } from "./guestNav/guestNavList";
import {
	IPersonalDetails,
	IClientProfilePicture,
	IServicingDetails,
	ICOMPersonalDetails,
	ICOMServicingDetails
} from "../types/components/login/userDetails";
import { UserNav } from "./client/clientNav";
import { setbStrg } from "../service/storageHelper";
import { Idevice } from "../types/device";
import DeviceContext from "../service/indentifyDevice";
import { MobCurtainMenu } from "./mobMenu/mobMenuNav";
import LoginService from "../service/login/loginService";
import { IdxStream } from "./stream/indxStream";

import { AClientProfilePicture, AProfileGetPersonalDetails, AServicingDetails } from "../service/postLogin/clientProfileAPIService";
import { GlobalSearch } from "./globalSearch/globalSearch";
import logo from "../../assets/images/logo_blue.jpg";
import jwt_decode from "jwt-decode";
import { useQuery } from "../service/urlHelper";
import { getloginDataforApp } from "../service/serviceRequest/srApiService";
import { apiService } from "../service/apiService";
import handleCookies from "../service/cookiesHelper";

const handleDevice: Idevice = DeviceContext();
if (handleDevice.isDesktop) {
	require("../../assets/scss/components/header/headerDesk.scss");
} else if (handleDevice.isMobile) {
	require("../../assets/scss/components/header/headerMob.scss");
}

export interface IEdHeaderProps {}

export function EdHeader(__props: IEdHeaderProps) {
	// const [fixedHeader, setFixedHeader] = React.useState<boolean>(false); //used to hide/show header streamer
	const [isLoggedIn, setIsLoggedIn] = React.useState<boolean>(LoginService.isLoggedIn()); //defines if user logged in or not
	const [toggleMenuAct, setToggleMenuAct] = React.useState<boolean>(false);
	const [userProfile, setUserProfile] = React.useState<IPersonalDetails | ICOMPersonalDetails>();
	const [ClientProfilePicture, setClientProfilePicture] = React.useState<IClientProfilePicture>();
	const [servicingDetails, setServicingDetails] = React.useState<IServicingDetails | ICOMServicingDetails>();
	const [authToken, setAuthToken] = React.useState<any>("");
	const queryObject = useQuery();
	//on scroll rearrange the menu items in header
	// const handleHeader = () => {
	// 	//hide/show the top layer of header if  vertical scroll depth > 50px

	// 	setFixedHeader(document.documentElement.scrollTop > 50 || document.body.scrollTop > 50 ? true : false);
	// };
	//callback methods start
	const GetPersonalDetails = (res: IPersonalDetails | ICOMPersonalDetails) => {
		setUserProfile(res);
		setbStrg("PersonalDetails", res);
		ee.emit("fetchProfile", res);
	};

	const GetClientPicture = (res: IClientProfilePicture) => {
		if (res?.ImageName && res?.ProfileImageByte) {
			res.ProfileImageByte = "data:image/" + res.ImageName.split(".").pop() + ";base64," + res.ProfileImageByte;
			setbStrg("ClientProfilePicture", res);
			setClientProfilePicture(res);
		}
	};

	const GetServicingDetails = (res: IServicingDetails | ICOMServicingDetails) => {
		setbStrg("servicingDetails", res);
		setServicingDetails(res);
	};
	React.useEffect(() => {
		const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
		if(params && params.auth_token) {
			var req: any = {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                },
              };
            req.headers["appidkey"] =  urlConfig.appidkey;
            req.headers.Source = sessionStorage.getItem("source") || "edel";
			fetch(
                urlConfig.getloginDataforApp,
                req
            ).then((response : any) => {
                response.json()
                })
            .then((data:any) => {
               return data;
            })
		}
		
		apiService(
            {
                url: urlConfig.getloginDataforApp,
                method: "GET",
                authType: "authtoken",
                appidkey: urlConfig.appidkey,
                source: sessionStorage.getItem("source") || undefined,
                sourcetoken: sessionStorage.getItem("sourceToken") || undefined,
            },
            (res: any) => {
                console.log(res)
                window.localStorage.setItem("acc_data", JSON.stringify(res?.data?.lgnData));
				window.localStorage.setItem("isInvestmentAcc", JSON.stringify(!!res?.data?.lgnData?.accs?.invAccountDetails?.invOnlyAcc));
            }
        );
	}, []);

	React.useEffect(() => {
		if (isLoggedIn) {
			//personalDetails API call
			// AProfileGetClientDetails(GetClientDetails, "All", "EQ");
			AProfileGetPersonalDetails(GetPersonalDetails);

			//ClientProfilePicture api call
			AClientProfilePicture(GetClientPicture);

			//ServicingDetails api call
			AServicingDetails(GetServicingDetails);
		}
	}, [isLoggedIn]);

	return (
		<>
			<header className="edelHeader">
					
							<section className="upperLayer">
								<IdxStream />
							</section>
					
						{/* block only for desktop end */}
						{/* ************************************************************** */}
					
						<section className="lowerLayer">
						
							{/* block only for desktop start*/}
							{/* navigation bar which contains menu list */}
							{handleDevice.isDesktop && (
								<div className="navBarDiv ib vTop ">
										<a href={config.rootUrl} className="Elogo ib vTop">
								{/* logo on header which will always navigate to home page */}
								{/* <EdelLogo fill="#fff" viewbox={handleDevice.isDesktop ? "0 0 106.2 15" : "0 0 102 22"} width="" height="" /> */}
								{/* <i className="edel-icon-edel-logo1"></i> */}
								<img src={logo} alt="nuvama"/>
							</a>
									{/* //menu list start */}
									<MenuList deviceState={handleDevice} loggedIn={isLoggedIn} />
									{/* //menu list end */}
									{/* search start */}
									{/* <div className="ib"> */}
									<GlobalSearch />
									{/* </div> */}
									{/* search end */}
									{!isLoggedIn && (
										<div className="ib pdl-10 vTop d-flex">
											<div>
											<a className="openAccBtn openAccBtn-lh-adjst vMid" href={config.rootUrl + "open-trading-account-online"}>
												Open Account
											</a></div>
											<LoginToNav />
										</div>
									)}

									{isLoggedIn && (
										<div className="ib vTop clientNavDD">
											{/* client navigation bar start */}
											{/* contains toc, reports, and profile naviagtion */}
											{isLoggedIn && (
												<UserNav
													userDetails={{
														clientPicture: ClientProfilePicture,
														personalDetails: userProfile,
														servicingDetails: servicingDetails
													}}
												/>
											)}
											{/* client navigation bar  end*/}
										</div>
									)}
								</div>
							)}
							{/* block only for desktop end*/}

							{/* block only for mobile start*/}
							{handleDevice.isMobile && (
								<>
									
									<div className="mobMenu fWid ib vMid">
										<div className="mobMenuIconSet">
										<button className="navbarTgl" onClick={(e) => setToggleMenuAct(!toggleMenuAct)}>
											<span className="icon-bar"></span>
											<span className="icon-bar"></span>
											<span className="icon-bar"></span>
										</button>
										<div className={"mobMenuContainer " + (toggleMenuAct ? "in" : "")}>
											<div className="blue_band f0">
												<div className="blkLeft ib vMid">
													<a href={config.rootUrl} className="Elogo">
														{/* logo on header which will always navigate to home page */}
														{/* <EdelLogo fill="#fff" viewbox="0 0 102 22" width="" height="" /> */}
														<img src={logo} alt="nuvama"/>
													</a>
												</div>

												<div className="blkRight vMid ib">
													<button className=" ed_link closeMenu" onClick={(e) => setToggleMenuAct(!toggleMenuAct)}>
														<i className="edel-icon-close"></i>
													</button>
												</div>
											</div>
											<MobCurtainMenu rootUrl={config.rootUrl} loggedIn={isLoggedIn} deviceState={handleDevice} />
										</div>
									</div>
									<a href={config.rootUrl} className="Elogo ib vTop">
								        {/* <i className="edel-icon-edel-logo1"></i> */}
										<img src={logo} alt="nuvama"/>
							         </a>	
										</div>
									<GlobalSearch />
								</>
							)}
							{/* block only for mobile end*/}
						</section>
					
				
			</header>
		</>
	);
}
